import { render, staticRenderFns } from "./MwanPaymentTemplate.vue?vue&type=template&id=e3ef8f6a&scoped=true"
import script from "./MwanPaymentTemplate.vue?vue&type=script&lang=js"
export * from "./MwanPaymentTemplate.vue?vue&type=script&lang=js"
import style0 from "./MwanPaymentTemplate.vue?vue&type=style&index=0&id=e3ef8f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ef8f6a",
  null
  
)

export default component.exports